import { useEffect, useState, useCallback } from "react";
import { fetchAndActivate, getValue } from "firebase/remote-config";
import { remoteConfig } from "../../bootstrap";

remoteConfig.settings.minimumFetchIntervalMillis = 3600000;

const useRemoteConfig = () => {
    const configFromLocalStorage = JSON.parse(localStorage.getItem("configFromLocalStorage")) || {};
    const [featureConfig, setFeatureConfig] = useState({ ...configFromLocalStorage });

    const fetchRemoteConfig = useCallback(() => {
        fetchAndActivate(remoteConfig)
            .then(() => {
                /* Getting the `kudabusiness_feature_config` from the firebase remote config and storing it in the local storage. */
                const configValue = getValue(
                    remoteConfig,
                    `${process.env.REACT_APP_K4B_FEATURE_KEY}`,
                )._value;
                const parseRes = JSON.parse(configValue);

                localStorage.setItem("configFromLocalStorage", configValue);
                setFeatureConfig(parseRes);
            })
            .catch((err) => {
                console.error(err);
            });
    }, []);

    useEffect(() => {
        fetchRemoteConfig();
        // eslint-disable-next-line
    }, []);

    return { featureConfig };
};

export default useRemoteConfig;
